export const FETCH_REPORTED = "fetchReported";
export const FETCH_DEFECT_SOLUTIONS = "getDefectSolutions";
export const UPDATE_REPORTED = "updateReported";
export const REPORTED_RESET_STATE = "resetReportedState";
export const UPDATE_USER = "updateUser";
export const CREATE_USER = "createUser";
export const FETCH_USER = "fetchUser";
export const RESET_USER = "resetUser";
export const UPDATE_USER_PERMISSIONS = "updateUserPermissions";

export const FETCH_PERMISSIONS = "fetchPermissions";
